import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface BucketIdFieldProps {}

export const BucketIdField: React.FC<BucketIdFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ bucket_id: number | null }>()

  const api = useApi()

  const query = useQuery({
    queryKey: ['static/buckets'],
    queryFn: () => api.buckets.getAll(),
  })

  const bucketOptions = useMemo(() => {
    return sortAlphabeticallyByKey(
      (query.data ?? []).map((d) => ({
        label: d.bucket_name,
        value: d.bucket_id ? d.bucket_id?.toString() : '',
      })),
      'label',
    )
  }, [query.data])

  return (
    <FormField
      name="bucket_id"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Bucket</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value?.toString()}
              showNone="None"
              setValue={(val) =>
                setValue('bucket_id', val !== '' ? parseInt(val) : null, {
                  shouldValidate: true,
                })
              }
              placeholder={'Select a bucket...'}
              options={bucketOptions}
            />
          </FormItem>
        )
      }}
    />
  )
}
